import * as React from "react";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { RecommendationAdminPortal } from "./RecommendationAdminPortal";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";
import { HomeBreadcrumbWrapper } from "../../components/breadcrumb/HomeBreadcrumbWrapper";

const RecommendationPortalRoute = () => {
    const { instanceId } = useRoutedParamsWithContext();
    return <RecommendationAdminPortal id={instanceId!} />;
};

export const recommendationRoutes = [
    {
        path: "/recommendation/:instanceId/admin",
        content: <RecommendationPortalRoute />,
        breadcrumbs: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <HomeBreadcrumbWrapper items={[
                {
                    text: "Instance Admin Portal",
                    href: `#/instance/${instanceId}/admin`
                },
                {
                    text: "Recommendation Admin Portal",
                    href: `#/recommendation/${instanceId}/admin`
                }
            ]}/>;
        },
        header: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaHeader headerType="Other" instanceId={instanceId!} />;
        },
        footer: () => {
            const { instanceId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="AdminPortal" entityId={instanceId!} />;
        }
    }
];
